import { combineReducers } from 'redux';

import couponExchange from './couponExchange';
import ssl from './ssl';
import newFeedback from './newFeedback';
import newUser from './newUser';
import letter from './letter';
import turntable from './turntable';

export default combineReducers({
  couponExchange,
  ssl,
  newFeedback,
  newUser,
  letter,
  turntable,
});
